import { BaseViewStore} from 'core/stores';
import { action, observable } from "mobx";

class NikoFacilityOrderConfirmationModalStore extends BaseViewStore {
    @observable accessor disabled = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.icon = this.modalParams.data.icon;
        this.title = this.modalParams.data.title;
        this.additionalMessage = this.modalParams.data.additionalMessage;
        this.validate = this.modalParams.data.validate;
    }

    @action.bound
    async action() {
        if (this.validate && this.validate() === false) {
            return;
        }

        this.disabled = true;
        try {
            await this.modalParams.data.action();
            this.modalParams.close();
        }
        catch (err) {
            this.disabled = false;
            return this.onUpdateError(err);
        }
        this.disabled = false;
    }
}

export default NikoFacilityOrderConfirmationModalStore;
